import {
  toI18nMessageId,
  useI18n,
  useStaticIntl,
} from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import {
  SystemSpaceSlug,
  useAuthMember,
  useSpaceUtil,
} from '@tribeplatform/react-sdk/hooks'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { BC } from '../../types/index.js'
import { mainMenuActiveIcons, mainMenuIcons } from './constants.js'
import { MainMenuAction, MainMenuProps } from './types.js'
import { getDeprecatedItemsCleaner } from './utils.js'

export const MainMenuBlock: BC<MainMenuProps> = ({
  items: _items,
  ...rest
}) => {
  const { getMessageByDynamicId } = useI18n()
  const { Link, location } = useRouter()

  const { data: authMember } = useAuthMember()
  const { generateProfilePath, matchPath, hasViewPermission } = useSpaceUtil()
  const deprecatedItemsCleaner = useStaticIntl(getDeprecatedItemsCleaner)

  const items = deprecatedItemsCleaner(_items)

  const pathMapping = {
    [SystemSpaceSlug.HOME]: '/',
    [SystemSpaceSlug.MEMBERS]: '/members',
    [SystemSpaceSlug.SPACES]: '/spaces',
    [SystemSpaceSlug.NOTIFICATIONS]: '/notifications',
    [SystemSpaceSlug.SEARCH]: '/search',
  }

  return (
    <NavVertical {...rest}>
      <NavVertical.Group>
        {items
          .map(item => {
            if (!item.enabled) {
              return null
            }
            const IconComponent = mainMenuIcons[item.icon]
            const ActiveIconComponent = mainMenuActiveIcons[item.icon]
            let matched
            let isActive: boolean

            const spacePath = pathMapping[item?.spaceSlug] || '/'

            const labelText = getMessageByDynamicId(
              toI18nMessageId('Navigation', item.label),
              item.label,
            )

            switch (item.action) {
              case MainMenuAction.OPEN_LINK:
                return (
                  <NavVertical.Item
                    key={item.label}
                    as={Link}
                    variant="inherit"
                    href={item.link}
                    active={false}
                    leadingIcon={<IconComponent />}
                    target="_blank"
                  >
                    {labelText}
                  </NavVertical.Item>
                )
              case MainMenuAction.OPEN_PROFILE:
                if (!hasViewPermission(SystemSpaceSlug.MEMBER)) {
                  return null
                }
                matched = matchPath(SystemSpaceSlug.MEMBER, location.pathname)
                isActive = matched && matched?.params?.id === authMember?.id
                return (
                  <NavVertical.Item
                    key={item.label}
                    as={Link}
                    variant="inherit"
                    href={generateProfilePath()}
                    active={isActive}
                    leadingIcon={
                      isActive ? <ActiveIconComponent /> : <IconComponent />
                    }
                  >
                    {labelText}
                  </NavVertical.Item>
                )
              case MainMenuAction.OPEN_SPACE:
                if (!spacePath) {
                  return null
                }
                matched = spacePath === location.pathname
                return (
                  <NavVertical.Item
                    key={item.label}
                    as={Link}
                    variant="inherit"
                    href={spacePath}
                    active={!!matched}
                    leadingIcon={
                      matched ? <ActiveIconComponent /> : <IconComponent />
                    }
                  >
                    {labelText}
                  </NavVertical.Item>
                )
              default:
                return null
            }
          })
          .filter(item => item)}
      </NavVertical.Group>
    </NavVertical>
  )
}
